import { createNanoEvents } from "@-/com.npmjs.nanoevents";

interface BrowseResetEvents {
  reset: () => void;
}

const browseResetEmitter = createNanoEvents<BrowseResetEvents>();

/**
 * Module-scoped emitter used to reset the inner material top tab back to **Levels**
 * (`navigate("levels")`) from outside this layout — typically the bottom-tab `tabPress` listener
 * after it has dismissed the cards Stack to the cards browse UI. The levels layout also handles
 * this event by scrolling its focused list to the learner's current level.
 */
export function subscribeBrowseReset(subscriber: () => void) {
  return browseResetEmitter.on("reset", subscriber);
}

export function requestBrowseReset(): void {
  browseResetEmitter.emit("reset");
}
